import { useMutation } from "@apollo/client/react";
import { CREATE_AML_RULE_COMMENT } from "../../mutations/aml/createAmlRuleComment";
import GET_CLIENT_RISK_SCORE from "../../queries/aml/getClientRiskScore";

export const useCreateAmlRuleComment = ({ onCompleted, onError }: any) => {
  const [createAmlRuleComment, { data, loading, error }] = useMutation<String>(
    CREATE_AML_RULE_COMMENT,
    {
      onCompleted: onCompleted,
      onError: onError,
      refetchQueries: [GET_CLIENT_RISK_SCORE],
      awaitRefetchQueries: true,
    },
  );

  return { createAmlRuleComment, data, loading, error };
};
